import axios from 'axios';

const get = () => axios.get('/fornecedor/visualizacao');

export default {
  get,
};
